/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/


export const WebAppStationGroupDtoAccessTypeEnum = {
    OWNED: "OWNED",
    SHARED: "SHARED"
} as const;

export type WebAppStationGroupDtoAccessTypeEnumKey = (typeof WebAppStationGroupDtoAccessTypeEnum)[keyof typeof WebAppStationGroupDtoAccessTypeEnum];

export type WebAppStationGroupDto = {
    /**
     * @description Station group unique identifier
     * @type string, uuid
    */
    id: string;
    /**
     * @description Station group display name
     * @type string
    */
    name: string;
    /**
     * @description URL-safe unique slug
     * @type string
    */
    slug: string;
    /**
     * @description Stations belonging to this group (when joined)
     * @type array | undefined
    */
    stations?: {
        /**
         * @description Station unique identifier
         * @type string, uuid
        */
        id: string;
        /**
         * @description Station display name
         * @type string
        */
        name: string;
        /**
         * @description URL-safe unique slug
         * @type string
        */
        slug: string;
    }[];
    /**
     * @description Access relation for the requesting client: OWNED, SHARED, or null when not scoped
     * @type string
    */
    accessType?: WebAppStationGroupDtoAccessTypeEnumKey | null;
};